import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { signInWithCustomToken } from 'firebase/auth';
import { doc, setDoc } from 'firebase/firestore';
import { v4 as uuidv4 } from 'uuid';
import { httpsCallable } from 'firebase/functions';
import { auth, db, functions } from '../../firebase';
import { telegramLoginData } from '../../common/utils/helper';
import { ToastType } from '../../Contexts/Notification';
import { showToast } from 'App';

// Type declarations for Telegram Web App API
declare global {
  interface Window {
    Telegram?: {
      WebApp?: {
        ready: () => void;
        initData: string;
        expand: () => void;
      };
    };
  }
}

interface HandleTelegramLoginResultParams {
  data: any;  
}

interface UseTelegramLoginReturn {
  isLoading: boolean;
  LoginWithTelegram: () => Promise<void>;
}

export const useTelegramLogin = (): UseTelegramLoginReturn => {
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  
  const telegramLoginFuncation = httpsCallable(functions, "telegramLogin");
  const createUser = httpsCallable(functions, "createUser");

  async function handleTelegramLoginResult(data: HandleTelegramLoginResultParams) {       
    try {
      setIsLoading(true);

      const userCredential = await signInWithCustomToken(auth, data.data.result);

      const uid = userCredential?.user?.uid;
      if (!uid) {
        throw new Error("User UID is missing after sign-in.");
      }

      // @ts-ignore
      const isNewUser = userCredential?._tokenResponse?.isNewUser;      
      // @ts-ignore
      // setShowError("238"+JSON.stringify(userCredential?._tokenResponse))      
      if (isNewUser) {
        try {
          const result = await createUser({ uid });
          const userRef = doc(db, "users", uid);
          const activeSessionId = uuidv4();
          localStorage.setItem("activeSessionId", activeSessionId);
          await setDoc(userRef, { activeSessionId, firstTimeLogin: false }, { merge: true });          
          // navigate("/apps");
          navigate(`/?token=${data.data.result}`);
          // @ts-ignore
          if (result?.data?.status === false) {
            // @ts-ignore
            showToast(result?.data?.message, ToastType.ERROR);
          }                    
        } catch (err: any) {
          showToast(err?.message || "An error occurred", ToastType.ERROR);
        } finally {
          setIsLoading(false);
        }
      } else {        
        navigate(`/?token=${data.data.result}`);
        // navigate(`/apps`);
        setIsLoading(false);        
        // setShowError("260"+JSON.stringify(data.data.result))
      }
    } catch (error: any) {
      setIsLoading(false);
      showToast(error?.message || "An error occurred", ToastType.ERROR);
    }
  }

  const LoginWithTelegram = async () => {
    // @ts-ignore
    window.Telegram.WebApp.ready();
    // @ts-ignore
    window.Telegram.WebApp.expand();
    // @ts-ignore
    const initData = window.Telegram.WebApp.initData;

    const params = new URLSearchParams(window.location.search);
    const inituserData = params.get("inituserData");       
    if (inituserData || initData) {
      setIsLoading(true);
      const payloadData = await telegramLoginData(inituserData ||initData);
      const data = await telegramLoginFuncation(payloadData).then((result: any) => {
        setIsLoading(false);                        
        // @ts-ignore
        if (result?.data?.status == false) {
          // @ts-ignore
          showToast(result?.data?.message, ToastType.ERROR);
        } 
        // @ts-ignore
        if(result?.data?.status == true){            
          handleTelegramLoginResult(result);
        }
        return result;
      }).catch((err: any) => {
        setIsLoading(false);
        showToast(err.message, ToastType.ERROR);
        // setShowError("301")
      });     
    }
    else{      
    }
  };

  return {
    isLoading,
    LoginWithTelegram
  };
};